import { render, staticRenderFns } from "./KamVerificationDetail.vue?vue&type=template&id=ffc0cdc2&"
import script from "./KamVerificationDetail.vue?vue&type=script&lang=js&"
export * from "./KamVerificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./KamVerificationDetail.vue?vue&type=style&index=0&id=ffc0cdc2&prod&lang=css&"
import style1 from "./KamVerificationDetail.vue?vue&type=style&index=1&id=ffc0cdc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports